import React from "react";

export default function RatingInput({ index, label, name, value, onChange }) {
  return (
    <fieldset
      style={{
        borderRadius: "12px",
        border: "1px solid #dfe8ee",
        background: "#fff",
        padding: "16px",
        boxShadow: "0 10px 26px rgba(36,55,70,0.06)",
      }}
    >
      <legend style={{ position: "absolute", width: "1px", height: "1px", overflow: "hidden", clip: "rect(0,0,0,0)" }}>{label}</legend>
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span
            style={{
              display: "flex",
              height: "36px",
              width: "36px",
              flexShrink: 0,
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px",
              background: "#028D93",
              fontSize: "16px",
              fontWeight: 700,
              color: "#fff",
              boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
            }}
          >
            {index}
          </span>
          <p style={{ fontSize: "14px", fontWeight: 600, lineHeight: "1.6", color: "#00293A" }}>{label}</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "8px" }}>
          {[1, 2, 3, 4, 5].map((rating) => {
            const isSelected = Number(value) === rating;
            return (
              <label
                key={rating}
                tabIndex={0}
                style={{
                  display: "flex",
                  minHeight: "44px",
                  cursor: "pointer",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "8px",
                  border: isSelected ? "1px solid #028D93" : "1px solid #e2e8f0",
                  fontSize: "14px",
                  fontWeight: 700,
                  background: isSelected ? "#028D93" : "#fff",
                  color: isSelected ? "#fff" : "#64748b",
                  transition: "all 0.15s ease",
                }}
              >
                <input
                  checked={isSelected}
                  style={{ position: "absolute", width: "1px", height: "1px", overflow: "hidden", clip: "rect(0,0,0,0)" }}
                  name={name}
                  onChange={() => onChange(rating)}
                  type="radio"
                  value={rating}
                />
                {rating}
              </label>
            );
          })}
        </div>
      </div>
    </fieldset>
  );
}
